import { useEffect, useMemo, useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

/** Fatia uma lista já filtrada/ordenada em páginas de tamanho fixo. A página
 * volta para 1 sempre que a lista de entrada muda de referência (nova busca,
 * novo filtro, recarregamento) — sem isso o usuário podia ficar preso numa
 * página que deixou de existir. */
export function usePagedItems<T>(items: T[], pageSize = 10) {
  const [page, setPage] = useState(1)
  useEffect(() => { setPage(1) }, [items])
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize))
  const page_ = Math.min(page, totalPages)
  const pageItems = useMemo(() => items.slice((page_ - 1) * pageSize, page_ * pageSize), [items, page_, pageSize])
  return { page: page_, setPage, totalPages, pageItems }
}

// Mesma composição da paginação do aplicativo: setas redondas e seletor de página.
export function Pagination({ page, totalPages, onChange }: { page: number; totalPages: number; onChange: (page: number) => void }) {
  if (totalPages <= 1) return null
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1)
  return <div className="pagination">
    <button type="button" className="pagination-nav" onClick={() => onChange(page - 1)} disabled={page <= 1} aria-label="Página anterior"><ChevronLeft/></button>
    <label className="pagination-select">Página
      <select value={page} onChange={event => onChange(Number(event.target.value))}>{pages.map(number => <option value={number} key={number}>{number}</option>)}</select>
      de {totalPages}
    </label>
    <button type="button" className="pagination-nav" onClick={() => onChange(page + 1)} disabled={page >= totalPages} aria-label="Próxima página"><ChevronRight/></button>
  </div>
}
